export default __webpack_public_path__ + "static/media/slider2.f734d2b5.jpg";